import React from "react"
import { css } from "@emotion/css"
import { getAuth, signOut } from "firebase/auth"

const LoadingBlanket: React.FC<{ color?: string; error?: string }> = ({
  color,
  error,
}) => (
  <div
    className={css`
      position: fixed;
      height: 100vh;
      width: 100vw;
      top: 0;
      left: 0;
      background-color: ${color ?? "#f2f2f2"};
      z-index: 1000000;
    `}
  >
    <p style={{ color: "black", padding: 10, marginLeft: 50 }}>{error}</p>
    {error ? (
      <p
        onClick={() => {
          signOut(getAuth())
        }}
        style={{ color: "black", opacity: 0.3, padding: 10, marginLeft: 50 }}
      >
        log out
      </p>
    ) : null}
  </div>
)

export default LoadingBlanket
